import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";

/**
 * Component for rendering a delete button cell in the tasks table
 * @param {Object} props - Component props
 * @param {Function} props.onDelete - Callback function to open delete confirmation
 * @param {Object} props.data - Row data for the delete action
 * @returns {JSX.Element} Delete button cell
 */
const DeleteCell = ({ onDelete, data }) => (
  <Button size="small" onClick={() => onDelete(data)}>
    <DeleteIcon color="error" fontSize="small" />
  </Button>
);

export default DeleteCell;